import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelEmailComponent } from './model-email.component';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PipeModule } from '../../pipes';
import { SendMailModule } from '../send-mail';
import { InsertImageModule } from '../../insert-image';

@NgModule({
  declarations: [ModelEmailComponent],
  exports: [ModelEmailComponent],
  imports: [
    CommonModule,
    FormsModule,
    CKEditorModule,
    PipeModule,
    SendMailModule,
    InsertImageModule
  ]
})

export class ModelEmailModule { }
